import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["storesSheet", "termsSheet", "otherAreaStores", "otherAreaStoresLink"];

  declare storesSheetTarget: HTMLElement;
  declare termsSheetTarget: HTMLElement;
  declare otherAreaStoresTarget: HTMLElement;
  declare otherAreaStoresLinkTarget: HTMLElement;

  show(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.termsSheetTarget.classList.remove("is-active");
    this.storesSheetTarget.classList.add("is-active");
  }

  showOtherAreas(event: Event) {
    event.preventDefault();
    this.otherAreaStoresTarget.classList.remove("is-completely-hidden");
    this.otherAreaStoresLinkTarget.classList.add("is-completely-hidden");
  }
}
